
import styled from "styled-components";
import { Grid } from "@material-ui/core";
import { FormikInputTypeAhead, FormikInputPercent, FormikInputNumber, FormikInputMoney, FormikInputText } from "@loanbossinc/component-library";

export const Divider = styled.div`&& {    
    border: 1px solid #DADCE0;
    width: 100%;
    height: 0px;
    margin-top:30px;
}`;

export const StyledGridContainer = styled(Grid)`&&{
    margin-top: 26px;
}`;
export const StyledLinkContainer = styled(Grid)`&&{
    margin-top: 26px;
    margin-left: 16px;
}`;
export const StyledLinkContainerRight = styled(StyledLinkContainer)`&&{
    float: right
    margin-left: 0;
}`;
export const StyledFormikInputNumber = styled(FormikInputNumber)`&&&&{
    width: 100%
}`;
export const StyledFormikInputMoney = styled(FormikInputMoney)`&&&&{
    width: 100%
}`;
export const StyledFormikInputPercent = styled(FormikInputPercent)`&&&&{
    width: 100%
}`;
export const StyledFormikInputText = styled(FormikInputText)`&&&&{
    width: 100%
}`;
export const StyledFormikInputTypeAhead = styled(FormikInputTypeAhead)`
    border-bottom: 1px solid #2196F3;
    width: 100%;
`;
export const StyledHeaderContainer = styled(Grid)`&&{
    margin-top: 23px;
}`;
export const StyledHeader = styled.span`&&{
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;

    color: #000000;
}`;
export const StyledTermSheetButon = styled.div`&& {
    background: #F5F3F3;
    border: 1px solid #005AA9;
    box-sizing: border-box;
    border-radius: 8px;
    height: 72px;
    width: 528px;
    margin: auto;
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #005AA9;
    margin-top: 26px;
    cursor: pointer;
  }`;
export const StyledTermSheetButonBlueSM = styled(StyledTermSheetButon)`&& { background: #005AA9; color: #F5F3F3; width: 132px; height: 36px;}`;
export const StyledButton = styled.div`&& { margin-top: 30px; }`;
export const StyledButtonCenteredSM = styled(StyledButton)`&& { text-align: center; margin-top: 7px;}`;
export const StyledLinkText = styled.div`&& { color: #005AA9; cursor: pointer;}`;
export const StyledLinkTextFloatRight = styled.div`&& { color: #005AA9; cursor: pointer; float:right;}`;
export const StyledPrepaymentScheduleContainer = styled(Grid)`&& { 
    width: 528px;
    /* Fill / White */
    background: #FFFFFF;

    /* Stroke / Gray */
    border: 1px solid #DADCE0;
    box-sizing: border-box;
    border-radius: 8px 8px 0px 0px;
    margin-top: 16px;
    padding-bottom: 16px;
    padding-left: 16px;
    padding-right: 16px;
  }`;
export const StyledPrepaymentScheduleContainerFooter = styled(Grid)`&& { 
    width: 528px;
    height: 52px;
    
    /* Fill / Gray */    
    background: #FAFAFA;

    /* Stroke / Gray */    
    border: 1px solid #DADCE0;
    box-sizing: border-box;
    border-radius: 0px 0px 8px 8px;
  }`;
